import {
  RIDE_NEAR_ME_DATA_START,
  RIDE_NEAR_ME_DATA_SUCCESS,
  RIDE_NEAR_ME_DATA_ERROR,
  USER_RIDE_NEAR_ME_DATA_START,
  USER_RIDE_NEAR_ME_DATA_SUCCESS,
  USER_RIDE_NEAR_ME_DATA_ERROR
} from "Constant/RentalCustomer";
const initialState = {
  loading: false,
  data: [],
  userRideData: []
};

export default function rideNearYouDataReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case RIDE_NEAR_ME_DATA_START:
      return {
        ...state,
        data:[],
        loading: true,
      };
    case RIDE_NEAR_ME_DATA_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case RIDE_NEAR_ME_DATA_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case USER_RIDE_NEAR_ME_DATA_START:
      return {
        ...state,
        userRideData: [],
        loading: true,
      };
    case USER_RIDE_NEAR_ME_DATA_SUCCESS:
      return {
        ...state,
        userRideData: action.payload,
        loading: false,
      };
    case USER_RIDE_NEAR_ME_DATA_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    default:
      return state;
  }
}
